/* eslint-disable consistent-return */
import { parse } from 'query-string'
// eslint-disable-next-line camelcase
import { decode_object } from 'rison'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { LIMITS, REGEX } from '@weblite/permission'
import { WappMode } from '@weblite-wapps/protocol'
import { CallType } from '@weblite/ts-action/media-proxy'
import hostConf from '$config/frontend'
import { getShortLinkTarget, URL_SHORTENER_PATTERN } from '$func/link-shortener'
import { showJoinHallModal } from '$comp/modals/join-hall-dialog'
// import { showRequestToJoinHallModal } from '$comp/modals/request-to-join-hall'
import { getHallByIdentifier, getHallByInviteLink } from '$logic/hall'
import { getSubscription, joinHall } from '$logic/subscription'
import { openRoom } from '$logic/opened-room'
import { showLoadFromServerLoadingModal } from '$comp/modals/loading-modal'
import {
  showInvalidLinkSnackbar,
  showUsernameIsInvalidErrorSnackbar,
} from '$comp/snackbars'
import { showOpenLinkConfirmModal } from '$comp/modals/confirmation-dialog'
import { isLoggedIn, loginUserFromRouter } from '$logic/auth'
import { handleSharedTarget } from '$logic/shared-target'
import { getPvByUserId } from '$logic/pv'
import { OverlayWappPanel, WappPanel } from '$logic/wapp-panels'
import { urlToLoadAfterLoginStorage } from '$logic/router/storage'
import { addProtocolToUrl } from '$func/link'
import { getUserByUsername } from '$logic/users'
import { callService, callStorage } from '$logic/call'
import { connectionCallbackManager } from '$logic/auth/events'
import { disableStartupDialogs } from '$logic/router/helper'
import { isClientsRoom } from '$logic/room'
import { disableCheckForSynchronizePersist } from '$func/sync-versions'
import { showRequestToJoinHallModal } from '$comp/modals/request-to-join-hall'
import { checkTrialCanBeActivated } from '$logic/premium-features'

interface UrlHandler {
  match: RegExp
  handle: (
    pathname: string,
    urlParams: Record<string, any>,
    options?: UrlHandlerOptions,
  ) => Promise<unknown>
  runBeforeAuth?: boolean
}

interface UrlHandlerOptions {
  forceJoinChat?: boolean
  forceOpenLink?: boolean
}

export const inviteLinkRegex = new RegExp(`/[+].{${LIMITS.inviteLinkSize}}$`)
export const usernameRegex = new RegExp(`/${REGEX.username}$`)
export const messageIidRegex = new RegExp(`/${REGEX.username}/[0-9]+$`)

const URL_HANDLERS: UrlHandler[] = [
  {
    match: inviteLinkRegex,
    // '/+:inviteLink'
    handle: async pathname => {
      const inviteLink = pathname.slice(2)
      void showLoadFromServerLoadingModal()
      const res = await getHallByInviteLink(inviteLink)
      await closeCurrentModal()
      if (!res?.room) return

      const { hall, room } = res

      // NOTE: If client is member of hall, redirect to hall
      if (await getSubscription(room.id)) void openRoom(room.id)
      else if (res.inviteLink?.needsApproval)
        showRequestToJoinHallModal({ hall, room, link: inviteLink })
      else void showJoinHallModal({ hall, room, link: inviteLink })
    },
  },
  {
    match: usernameRegex,
    // '/:identifier'
    handle: async (pathname, _, options) => {
      console.log('username regex')
      const identifier = pathname.slice(1)
      void showLoadFromServerLoadingModal()
      const hall = await getHallByIdentifier(identifier)
      if (hall) {
        await closeCurrentModal()
        const roomId = hall.roomId
        if (options?.forceJoinChat) {
          analite('CHAT_JOIN', {
            source: 'CHAT_LIST_ADS',
            name: hall.identifier,
          })
          const isMember = isClientsRoom(roomId)
          if (isMember) await openRoom(roomId)
          else await joinHall(roomId)
        }
        void openRoom(roomId)
        return
      }
      const user = await getUserByUsername(identifier)
      if (user) {
        const pv = await getPvByUserId(user.id)
        await closeCurrentModal()
        if (pv) void openRoom(pv.roomId)
        return
      }
      showUsernameIsInvalidErrorSnackbar()
      await closeCurrentModal()
    },
  },
  {
    match: messageIidRegex,
    // '/:identifier/:iid'
    handle: async pathname => {
      const [, identifier, strIid] = pathname.split('/')
      void showLoadFromServerLoadingModal()
      const hall = await getHallByIdentifier(identifier)
      await closeCurrentModal()
      if (!hall) return
      void openRoom(hall.roomId, +strIid)
    },
  },
  {
    match: /^\/wapp\/.+$/,
    // '/wapp/:wappId'
    handle: async (pathname, params) => {
      const [, , wappId] = pathname.split('/')
      const {
        wisId,
        input: encodedInput,
        mode,
      } = params as {
        wisId?: string
        mode?: WappMode
        input?: string
      }

      const input = decode_object(encodedInput || '') as Record<string, any>

      if (mode === 'main' || !mode) WappPanel.openWapp({ wappId, wisId, input })
      else if (mode === 'overlay')
        void OverlayWappPanel.openWapp({ wappId, wisId, input })
    },
  },
  {
    match: new RegExp('/call-recorder+$'),
    // website.com/call-recorder?roomId={roomId}&callType={callType}&token={token}
    handle: async (_, params) => {
      disableStartupDialogs()
      disableCheckForSynchronizePersist()
      callStorage.setRecordMode(true)
      const { roomId, callType, token, callTitle, ...callInput } = params as {
        token: string
        roomId: string
        callType: CallType
        callTitle?: string
      } & Record<string, string>

      const callback = () => {
        connectionCallbackManager.removeCallback(callback)
        setTimeout(() => {
          callService.joinCallFromRouter(roomId, callType, callTitle, {
            recordMode: true,
            ...callInput,
          })
        }, 2000)
      }

      connectionCallbackManager.addCallback(callback)

      loginUserFromRouter(token)
    },
    runBeforeAuth: true,
  },
  {
    match: /^\/_share-target\/$/,
    // '/_share-target/*'
    handle: async () => {
      disableStartupDialogs()
      handleSharedTarget()
    },
  },

  {
    match: /^\/fromLanding/,
    // '/fromLanding'
    handle: async () => {},
  },

  {
    match: /^\/activate-demo/,
    // '/activate-demo/'
    handle: async () => {
      checkTrialCanBeActivated()
    },
  },

  {
    match: new RegExp('^/$'),
    handle: async (_, params) => {
      if (params.token) {
        loginUserFromRouter(params.token)
        return
      }
      if (params.roomId) void openRoom(params.roomId)
      else if (params.userId) {
        const pv = await getPvByUserId(params.userId)
        if (pv) void openRoom(pv.roomId)
      }
    },
    runBeforeAuth: true,
  },
]

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const APP_URLS_REGEXP = import.meta.env.VITE_APP_URLS_REGEXP as string
export const APP_URL_PATTERN = APP_URLS_REGEXP
  ? new RegExp(APP_URLS_REGEXP, 'gm')
  : null

export async function handleLink(
  link: string,
  options?: UrlHandlerOptions,
): Promise<void> {
  if (!link.startsWith('http'))
    return handleLink(addProtocolToUrl(link), options)

  // NOTE: Handle links of url-shortener
  if (link.match(URL_SHORTENER_PATTERN)) {
    void showLoadFromServerLoadingModal()
    const target = await getShortLinkTarget(link)
    await closeCurrentModal()
    if (target) return handleLink(target, options)
    showInvalidLinkSnackbar()
    return
  }

  const linkMatchesWithAppPattern =
    (APP_URL_PATTERN && link.match(APP_URL_PATTERN)) ||
    link.startsWith(hostConf.FRONT_HOST)

  if (!linkMatchesWithAppPattern) {
    if (options?.forceOpenLink) {
      window.open(link, '_blank')
      return
    }

    void showOpenLinkConfirmModal(link, () => window.open(link, '_blank'))
    return
  }

  const { pathname, search } = new URL(link)
  const params = parse(search)

  const handler = URL_HANDLERS.find(({ match }) => match.test(pathname))
  console.log('handler', handler)

  if (!isLoggedIn() && !handler?.runBeforeAuth) {
    urlToLoadAfterLoginStorage.set(link)
    return
  }

  if (handler) await handler.handle(pathname, params, options)
  else {
    console.log('invalid link')
    showInvalidLinkSnackbar()
  }
}
